import axios from 'axios';

const instance = axios.create({
	baseURL: 'https://durex-360.firebaseio.com/',
	headers: { 'crossDomain': true },
});

export default instance;